import { log } from "../../utils";
import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { OfflineMessage } from "../../xapp/ChatServer";

export default function sendOfflineMsg(data: OfflineMessage): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.sendOfflineMsg(data, (err?: Error) => {
            if (err) {
                log(err);
            }
        });
    };
}
